(() => {
  const mount = () => {
    const page = document.getElementById('ug-jp-spokesperson-page');
    if (!page) return;
    page.ugPageCleanup?.();
    const controller = new AbortController();
    const media = window.matchMedia('(max-width: 767px)');
    const surfaces = [
      ['.ug-jpe', null],
      ['ug-jp-spokesperson-series', '--ug-jps-background'],
      ['ug-jp-spokesperson-activities', '--ug-jpa-background'],
      ['ug-jp-spokesperson-special', '--ug-jpsv-bg'],
      ['.ug-jpabout', '--ug-jpabout-bg'],
    ];
    let frame = 0;
    const measure = () => {
      frame = 0;
      const active = [];
      surfaces.forEach(([selector, variable]) => {
        page.querySelectorAll(selector).forEach((surface) => {
          const eligible = selector !== '.ug-jpe' || !media.matches;
          const color = variable ? getComputedStyle(surface).getPropertyValue(variable).trim().toLowerCase() : '#fff';
          surface.toggleAttribute('data-jp-page-surface', variable !== null && eligible && ['#f7f7f7', '#ffffff', '#fff'].includes(color));
          if (eligible) active.push(surface.getBoundingClientRect());
        });
      });
      if (!active.length) {
        page.style.removeProperty('--ug-jp-surface-top');
        page.style.removeProperty('--ug-jp-surface-height');
        return;
      }
      const top = Math.min(...active.map((rect) => rect.top));
      const bottom = Math.max(...active.map((rect) => rect.bottom));
      page.style.setProperty('--ug-jp-surface-top', `${top - page.getBoundingClientRect().top}px`);
      page.style.setProperty('--ug-jp-surface-height', `${Math.max(0, bottom - top)}px`);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    const resize = new ResizeObserver(schedule);
    const observe = () => {
      resize.disconnect();
      resize.observe(page);
      Array.from(page.children).forEach((section) => resize.observe(section));
      schedule();
    };
    const mutations = new MutationObserver(observe);
    mutations.observe(page, { childList: true });
    media.addEventListener('change', schedule, { signal: controller.signal });
    document.addEventListener('shopify:section:load', observe, { signal: controller.signal });
    document.addEventListener('shopify:section:reorder', schedule, { signal: controller.signal });
    document.fonts.ready.then(() => {
      if (!controller.signal.aborted) schedule();
    });
    const resetButtons = () => {
      if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
        page.classList.add('is-touch');
      }
      const active = document.activeElement;
      if (active && page.contains(active) && typeof active.blur === 'function') active.blur();
      page.classList.add('is-button-reset');
      window.clearTimeout(page.ugButtonResetTimer);
      page.ugButtonResetTimer = window.setTimeout(() => page.classList.remove('is-button-reset'), 120);
    };
    page.addEventListener('touchstart', () => page.classList.add('is-touch'), { passive: true, once: true, signal: controller.signal });
    window.addEventListener('pageshow', resetButtons, { signal: controller.signal });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') resetButtons();
    }, { signal: controller.signal });
    page.ugPageCleanup = () => {
      controller.abort();
      resize.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      window.clearTimeout(page.ugButtonResetTimer);
    };
    observe();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
